import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { useTranslation } from '../../i18n';
import { formatMoney } from '../../utils/format';

// Module-level constants — extracted from inline objects to avoid recharts subtree re-renders.
const AXIS_TICK = { fontSize: 10, fill: '#64748B' };
const TOOLTIP_STYLE = {
  fontSize: 12,
  borderRadius: 6,
  background: '#111726',
  border: '1px solid #283556',
  color: '#F8FAFC',
};
const TOOLTIP_LABEL_STYLE = { color: '#94A3B8' };
const TOOLTIP_FORMATTER = (value) => [formatMoney(value), ''];

export function TreasuryChart({ chartData }) {
  const { t } = useTranslation();
  return (
    <div className="surface-card overflow-hidden">
      <div className="px-4 py-3 border-b border-ink-600">
        <h3 className="font-display text-sm font-bold text-foreground tracking-tight uppercase">
          {t('treasury_evolution')}
        </h3>
      </div>
      <div className="p-4">
        {chartData.length > 1 ? (
          <ResponsiveContainer width="100%" height={210}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#1A233A" />
              <XAxis dataKey="name" tick={AXIS_TICK} stroke="#283556" />
              <YAxis tick={AXIS_TICK} stroke="#283556" />
              <Tooltip
                formatter={TOOLTIP_FORMATTER}
                contentStyle={TOOLTIP_STYLE}
                labelStyle={TOOLTIP_LABEL_STYLE}
              />
              <Line type="monotone" dataKey="trésorerie" stroke="#3B82F6" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-[200px] flex items-center justify-center text-slate-500 text-xs font-mono uppercase tracking-wider">
            {t('data_after_days')}
          </div>
        )}
      </div>
    </div>
  );
}
